const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.717"
      height="27.5"
      viewBox="0 0 29.717 27.5"
      className="stroke-current"
    >
      <g
        id="Group_9481"
        data-name="Group 9481"
        transform="translate(-592.368 -225)"
      >
        <path
          id="Path_12213"
          data-name="Path 12213"
          d="M-4260.533-15885.348l8.915,8.963,9.042-8.963"
          transform="translate(4858.774 16121.385)"
          fill="none"
          strokeLinecap="round"
          strokeWidth={3}
        />
        <path
          id="Path_12214"
          data-name="Path 12214"
          d="M-4260.533-15885.348s2.556,4,12.69,4,12.871-4,12.871-4"
          transform="translate(4854.973 16132.348)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={3}
        />
        <line
          id="Line_205"
          data-name="Line 205"
          y1={18}
          transform="translate(607.22 226.5)"
          fill="none"
          strokeLinecap="round"
          strokeWidth={3}
        />
      </g>
    </svg>
  )
}

export default DownloadIcon
